import {Textarea} from "@heroui/input";
import {Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, SelectItem} from "@heroui/react";
import {addToast} from "@heroui/toast";
import React, {useState} from 'react';
import {apiAction} from "../api.ts";
import PButton from "../components/PButton.tsx";
import PSelect from "../components/PSelect.tsx";
import {config} from "../config/config.ts";
import {useGlobalModal} from "../core/GlobalModal.tsx";

const FeatureRequest = ({
    onClose = () => {
    }
}) => {
    const globalModal = useGlobalModal();

    const [inProgress, setInProgress] = useState(false);

    const onCloseMain = () => {
        globalModal.close();
        onClose()
    }

    const [form, setForm] = useState({
        title:               'Issue Report',
        feature_description: '',
    });

    const handleSubmit = async () => {
        setInProgress(true);

        const res = await apiAction('submit-feature-request', form);

        if (res.error) {
            setInProgress(false);
            addToast({
                title: res.error || 'Request cannot be accepted right now. Please try again later.',
                color: 'danger',
            });
            return;
        }

        addToast({
            title: 'Thank you! Request was sent.',
            color: 'success',
        });
        onCloseMain();
    };

    return (
        <Modal isOpen={true} placement={"center"}
               isDismissable={false}
               isKeyboardDismissDisabled={true}
               onOpenChange={() => {
                   onCloseMain();
               }}
        >
            <ModalContent>
                {() => (
                    <>
                        <ModalHeader className="flex flex-col gap-1 pb-1">Contact Support</ModalHeader>
                        <ModalBody>
                            <PSelect
                                classNames={{helperWrapper: "hidden!"}}
                                selectedKeys={[String(form.title || '')]}
                                onSelectionChange={(e) => {
                                    setForm({...form, title: e.currentKey || ''})
                                }}
                                isRequired={true}
                                label="Type of request"
                            >
                                <SelectItem key={'Issue Report'}>Report an Issue</SelectItem>
                                <SelectItem key={'Feature Request'}>Feature Request</SelectItem>
                                <SelectItem key={'Other Support Request'}>Other</SelectItem>
                            </PSelect>

                            <form className="">
                                <Textarea
                                    autoFocus
                                    label={form.title === 'Issue Report' ? 'Describe your issue here' : 'Describe your suggestion'}
                                    placeholder={form.title === 'Feature Request' ? "Write your suggestion here..." : "Your message..."}
                                    defaultValue=""
                                    minRows={5}
                                    labelPlacement="outside"
                                    variant="flat"
                                    classNames={{inputWrapper: ""}}
                                    value={form.feature_description}
                                    required={true}
                                    onChange={(e) => setForm({...form, feature_description: e.target.value})}
                                />
                                <div className={"text-sm mt-1"}>
                                    App version: <span style={{color: '#555'}}>{config.version || config.appEnv + (config.isCordova ? 'm' : '')}</span>
                                </div>
                            </form>
                        </ModalBody>
                        <ModalFooter className="pt-1">
                            <PButton isLoading={inProgress} onPress={handleSubmit} color="primary">
                                Submit
                            </PButton>
                        </ModalFooter>
                    </>
                )}
            </ModalContent>
        </Modal>
    );
};

export default FeatureRequest;
